import type { LineageNodeData } from '@/types/lineage'

interface LineageNodeProps {
  data: LineageNodeData
}

export const LineageNode = (props: LineageNodeProps) => {
  const { data } = props

  const containerStyle = {
    width: '100%',
    height: '100%',
    background: '#fff',
    cursor: 'pointer',
    color: '#000',
    borderLeft: '4px solid #74A7BC',
    fontSize: 14,
    borderRadius: '4px',
    position: 'relative' as const,
    lineHeight: '18px',
    padding: '6px 12px',
  }

  return (
    <div style={containerStyle}>
      <div>{data?.name}</div>
      <div
        style={{
          width: '12px',
          height: '12px',
          position: 'absolute',
          left: -28,
          top: '50%',
          transform: 'translateY(-50%)',
          background: '#fff',
          borderRadius: '50%',
          color: '#D3DAE5',
          fontSize: '10px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #D3DAE5',
        }}
      >
        +
      </div>
    </div>
  )
}
